export default {
    color: '#c6cbe1',
    urls: ['/community', '/for-startups', '/for-investors', '/for-students', '/for-startup-programs']
}
